import axios from 'axios';
import { latLng } from "leaflet";
import state_translates from "@/data/translates/states/index.json"

export default {
  state: {
    destination: {
      destination: null,
      origin: null,
    },
    destination_id: null,
    set_transport: false,
    travel_mode: 'CAR',
    map_loads: null,
    zoom: 9,
    center: latLng(59.9308062, 30.3104669),
    location_profile: null,
    location: null,
    city: {name: 'Санкт-Петербург', state_code: 'SPE'}
  },
  mutations: {
    setDestination(state, params) {
      state.destination = params;
    },
    setDestinationId(state, id) {
      state.destination_id = id;
    },
    setTransport(state, value) {
      state.set_transport = value;
    },
    setTravelMode(state, mode) {
      state.travel_mode = mode;
    },
    addMapLoads(state) {
      state.map_loads++;
    },
    setMapZoom(state, zoom) {
      state.zoom = zoom;
    },
    setCenter(state, center) {
      state.center = center;
    },
    setLocationProfile(state, location) {
      state.location_profile = location;
    },
    setLocation(state, location) {
      state.location = location;
    },
    setMapCity(state, city) {
      state.city = city
    },

  },
  actions: {
    setMapCity({ commit }, city) {
      state_translates.ru[city.name] ? city.ru = state_translates.ru[city.name] : '';
      commit('setMapCity', city)
    },
    setLocation({ commit }, location) {
      commit('setLocation', location)
    },
    setLocationProfile({ commit }, location) {
      commit('setLocationProfile', location)
    },
    async setDestination({ commit }, params) {
      commit('setDestination', params);
    },
    async setTransport({ commit }, value) {
      commit('setTransport', value);
    },
    async setDestinationId({ commit }, id) {
      commit('setDestinationId', id);
    },
    async setTravelMode({ commit }, mode) {
      commit('setTravelMode', mode);
    },
    async setMapZoom({ commit }, zoom) {
      commit('setMapZoom', zoom);
    },
    async addMapLoads({ commit }) {
      try {
        await axios
          .get(`/api/statistic/map_loads`)
          .then(() => {
            commit('addMapLoads');
          })
      } catch (error) {
        console.error(error);
      }
    },
    setCenter({commit}, center) {
      commit('setCenter', center)
    }
  },
  getters: {
    getDestination: (s) => s.destination,
    getTransport: (s) => s.set_transport,
    getDestinationId: (s) => s.destination_id,
    getTravelMode: (s) => s.travel_mode,
    getMapZoom: (s) => s.zoom,
    getMapCenter: (s) => s.center,
    getMapLoads: (s) => s.map_loads,
    getLocationProfile: (s) => s.location_profile,
    getLocation: (s) => s.location,
    getMapCity: (s) => s.city
  },
};
